// extracted by mini-css-extract-plugin
module.exports = {"toaster":"Toaster_toaster__3J30n","toast":"Toaster_toast__hS2ax"};